<template>
  <div class="app">
    <el-row class="header" justify="space-between">
      <el-col :span="12" class="title">
        <span class="exam-title">{{joined_exam?.examType?.examTypeName}}操作技能考核</span>
      </el-col>
      <el-col :span="12" class="user-info">
        <div class="user-detail">
          <div class="info">
            <p>考生姓名: {{ userInfo?.name }}</p>
            <p>准考证号: {{ userInfo?.uname }}</p>
            <!-- <p>座位号: 018</p> -->
          </div>
        </div>
      </el-col>
    </el-row>

    <el-row class="exam-content">
      <el-col :span="12" class="exam-section">
        <div class="exam-info">
          <el-row justify="space-between" align="middle">
            <el-col :span="12">
              <h3>操作题(共{{ resultQuestionOperations.length }}题，合计100分)</h3>
            </el-col>
            <el-col :span="12" class="buttons-right">
              <a :href="sucaiPath" style="margin-right: 10px;" v-if="sucaiPath"><el-button type="primary" >下载本题素材</el-button></a>
              <el-button type="primary" @click="toggleFlag">标记</el-button>
            </el-col>
          </el-row>
          <div class="question-buttons">
            <el-button v-for="(operation, index) in resultQuestionOperations" :key="index"
              @click="showOperationQuestions(index)"
              :class="{ 'active-btn': currentOperationIndex == index, 'answered': Object.values(fileDict[operation.questionOperation?.qid] || {}).every(array => array.length > 0) }">
              {{ operation.questionOperation.questionCode }}
              <el-icon v-if="flaggedQuestions.includes(operation.questionOperation?.qid)" style="color: red;">
                <Flag />
              </el-icon>
            </el-button>
          </div>
          <div class="pdf-preview">
            <iframe :src="pdfSrc + '#toolbar=0'" width="100%" height="100%"></iframe>
          </div>
        </div>
      </el-col>
      <el-col :span="12" class="exam-section">
        <div class="questions">
          <h3>答题区</h3>
          <div v-for="(question, index) in currentOperationQuestions" :key="index" class="question-item">
            <h4>（{{ question.questionIndex + 1}}）{{ question.questions }}</h4>
            <div class="upload-button" :ref="`myElement-${currentOperationQid}-${question.id}`">
              <el-upload action="" multiple :before-upload="beforeUpload"
                v-model:file-list="fileDict[currentOperationQid][question.id]"
                :on-change="(file, fileList) => handleFileChange(file, fileList, question.id)"
                :on-remove="(file, fileList) => handleFileRemove(file, fileList, question.id)"
                :auto-upload="false">
                <el-button type="primary">上传答案</el-button>
              </el-upload>
            </div>
          </div>
          <div class="buttons">
            <el-button @click="prevOperation">上一题</el-button>
            <el-button @click="isAnswerCompleted"
              v-if="currentOperationIndex === resultQuestionOperations.length - 1" :disabled="checkTimeAndDuration()">提交答案</el-button>
            <el-button @click="nextOperation" v-else>下一题</el-button>
          </div>
        </div>
      </el-col>
    </el-row>

    <!-- 未答题交卷确认弹框 -->
    <el-dialog v-model="notCompleteDialog" title="未答题交卷确认" width="40%" align-center>
      <span>您还有{{ resultQuestionOperations.length - answeredNum }}道题未完成，确认交卷？</span>
      <template #footer>
        <span class="dialog-footer">
          <el-button @click="notCompleteDialog = false">取消并继续答题</el-button>
          <el-button type="primary" @click="notCompleteDialog = false; firstConfirmDialog = true">
            确认交卷
          </el-button>
        </span>
      </template>
    </el-dialog>

    <!-- 第一次交卷确认弹框 -->
    <el-dialog v-model="firstConfirmDialog" title="交卷确认第1次" width="40%" align-center>
      <span>如果您还想检查试卷，请点击”取消井返回”</span>
      <template #footer>
        <span class="dialog-footer">
          <el-button @click="firstConfirmDialog = false">取消并返回</el-button>
          <el-button type="primary" @click="firstConfirmDialog = false; secondConfirmDialog = true">
            确认交卷
          </el-button>
        </span>
      </template>
    </el-dialog>

    <!-- 第二次交卷确认弹框 -->
    <el-dialog v-model="secondConfirmDialog" title="交卷确认第2次" width="40%" align-center>
      <span>如果您还想检查试卷，请点击”取消井返回”</span>
      <template #footer>
        <span class="dialog-footer">
          <el-button @click="secondConfirmDialog = false">取消并返回</el-button>
          <el-button type="primary" @click="secondConfirmDialog = false; thirdConfirmDialog = true">
            确认交卷
          </el-button>
        </span>
      </template>
    </el-dialog>

    <!-- 第三次交卷确认弹框 -->
    <el-dialog v-model="thirdConfirmDialog" title="交卷确认第3次" width="40%" align-center>
      <span>如果您还想检查试卷，请点击”取消井返回”</span>
      <template #footer>
        <span class="dialog-footer">
          <el-button @click="thirdConfirmDialog = false">取消并返回</el-button>
          <el-button type="primary" @click="submitAnswers()" :loading="submitLoading">
            确认交卷
          </el-button>
        </span>
      </template>
    </el-dialog>
  </div>
</template>

<script>
/* eslint-disable */
import { mapGetters, mapActions } from 'vuex';
import { ElRow, ElCol, ElButton, ElInput, ElUpload, ElMessage, ElIcon, ElDialog } from 'element-plus';
import api from "@/utils/api";
import { Flag } from '@element-plus/icons-vue';
import { saveFile, getFile, deleteFile, clearDatabase } from '@/utils/indexedDB';

export default {
  components: {
    ElRow,
    ElCol,
    ElButton,
    ElInput,
    ElUpload,
    ElIcon,
    Flag,
    ElDialog
  },
  data() {
    return {
      userInfo: null, // 添加 userInfo 数据
      resultQuestionOperations: [],
      currentOperationQuestions: [],
      pdfSrc: '',
      fileDict: {},
      currentOperationQid: null,
      currentOperationIndex: 0,
      flaggedQuestions: [], // 存储标记的题目
      answeredNum: 0,
      notCompleteDialog: false, // 未完成对话框
      firstConfirmDialog: false, // 第一次确认对话框
      secondConfirmDialog: false, // 第二次确认对话框
      thirdConfirmDialog: false, // 第三次确认对话框
      submitIntervalId: null, // 定时器ID
      durationIntervalId: null, // 定时器ID
      sucaiPath: '',
      submitLoading: false, // 提交按钮加载状态
      startTime: null, // 考试开始时间
      endTime: null, // 考试结束时间
    };
  },
  computed: {
    ...mapGetters(['getJoinedExam']),
    joined_exam() {
      return this.getJoinedExam;
    }
  },
  async mounted() {
    const storedUserInfo = localStorage.getItem('userInfo');
    const storedCurrentOperationIndex = localStorage.getItem('currentOperationIndex');
    const storeFileDict = localStorage.getItem('fileDict');
    const storedFlaggedQuestions = localStorage.getItem('flaggedOperationQuestions');

    if (storedUserInfo) {
      this.userInfo = JSON.parse(storedUserInfo);
    }
    
    await fetch("fakeApi/getOperationPaper.json").then(response => {
        return response.json();
    }).then(response => {
      console.log('获取题目信息成功:', response.data);
      this.resultQuestionOperations = response.data ? response.data : []; 
    }).catch(error => {
      console.error('获取题目信息失败:', error);
    });

    // await api.getOpreationPaper(this.userInfo.uid, this.joined_exam.examid).then(response => {
    //   console.log('获取题目信息成功:', response.data);
    //   this.resultQuestionOperations = response.data ? response.data : []; 
    // }).catch(error => {
    //   console.error('获取题目信息失败:', error);
    // });

    if (storedFlaggedQuestions) {
      this.flaggedQuestions = JSON.parse(storedFlaggedQuestions);
    }

    if(storedCurrentOperationIndex && this.resultQuestionOperations.length > 0){
      this.showOperationQuestions(JSON.parse(storedCurrentOperationIndex));
    } else if (this.resultQuestionOperations.length > 0){
      this.showOperationQuestions(0);
    }

    // 更新已答题目数量
    let num = 0;
    for (let qid in this.fileDict) {
      if(Object.values(this.fileDict[qid]).every(array => array.length > 0)){
        num++;
      }
    }
    this.answeredNum = num;

    this.updateTimes();

    //计算剩余时间
    // this.submitIntervalId = setInterval(this.checkTimeAndSubmit, 1000);
    // this.durationIntervalId = setInterval(this.checkTimeAndDuration, 1000);

    // 初始化fileDict
    if (storeFileDict) {
      this.fileDict = JSON.parse(storeFileDict);
      for (const qid in this.fileDict) {
        for (const questionId in this.fileDict[qid]) {
          for (const file of this.fileDict[qid][questionId]) {
            const fileBlob = await getFile(`${qid}-${questionId}-${file.name}`);
            if (fileBlob) {
              // 转换回 File 类型
              const restoredFile = new File([fileBlob], file.name, { type: fileBlob.type });
              file.raw = restoredFile;
            } else {
              console.log('没有找到文件');
            }
          }
        }
      }
    } else {
      this.resultQuestionOperations.forEach(item => {
        this.fileDict[item.questionOperation.qid] = {};
        item.questionOperation.operationQuestions?.forEach(question => {
          this.fileDict[item.questionOperation.qid][question.id] = [];
        })
      });
    }
    console.log("this.fileDict", this.fileDict);
  },
  methods: {
    ...mapActions(['updateJoinedExam']),
    showOperationQuestions(index) {
      this.currentOperationIndex = index;
      //更新各项数据
      const operation = this.resultQuestionOperations[index];
      this.currentOperationQid = operation.questionOperation.qid;
      this.showPdfContent(operation.questionOperation.pdfPath);
      this.currentOperationQuestions = operation.questionOperation.operationQuestions.sort((a, b) => a.questionIndex - b.questionIndex);
      localStorage.setItem('currentOperationIndex', JSON.stringify(index));
      const sucaiPath = operation.questionOperation.sucaiPath;
      if(sucaiPath) {
        this.sucaiPath = `${sucaiPath}`;
      } else {
        this.sucaiPath = '';
      }
    },
    prevOperation() {
      if (this.currentOperationIndex > 0) {
        this.showOperationQuestions(this.currentOperationIndex - 1);
      }
    },
    nextOperation() {
      if (this.currentOperationIndex < this.resultQuestionOperations.length - 1) {
        this.showOperationQuestions(this.currentOperationIndex + 1);
      }
    },
    toggleFlag() {
      const index = this.flaggedQuestions.indexOf(this.currentOperationQid);
      if (index === -1) {
        this.flaggedQuestions.push(this.currentOperationQid);
      } else {
        this.flaggedQuestions.splice(index, 1);
      }
      localStorage.setItem('flaggedOperationQuestions', JSON.stringify(this.flaggedQuestions));
    },
    showPdfContent(pdfPath) {
      this.pdfSrc = `${pdfPath}`;
    },
    beforeUpload(file) {
      return true;
    },
    convertFileToBase64(file) {
      return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(file.raw);
        reader.onload = () => resolve(reader.result);
        reader.onerror = error => reject(error);
      });
    },
    convertBase64ToFile(base64String, filename) {
      // 提取Base64字符串中的MIME类型信息
      const mimeString = base64String.split(',')[0].split(':')[1].split(';')[0];
      // 解码Base64字符串，移除data URL前缀
      const byteString = atob(base64String.split(',')[1]);
      // 将二进制字符串转换为无符号8位整数数组
      const arrayBuffer = new ArrayBuffer(byteString.length);
      const uint8Array = new Uint8Array(arrayBuffer);

      for (let i = 0; i < byteString.length; i++) {
          uint8Array[i] = byteString.charCodeAt(i);
      }

      // 创建Blob对象
      const blob = new Blob([uint8Array], { type: mimeString });

      // 创建一个带有文件名的File对象
      const file = new File([blob], filename, { type: mimeString });
      
      return file;
    },
    async submitAnswers() {
      this.submitLoading = "false";
      const fileDict = this.fileDict;
      const answers = [];
      
      for (let operation of this.resultQuestionOperations) {
        const opQid = operation.questionOperation.qid;
        const operationQuestions = [];

        for (let subQuestion of operation.questionOperation.operationQuestions) {
          let base64Files = [];
          let fileNames = [];

          if (fileDict[opQid] && fileDict[opQid][subQuestion.id]) {
            const files = fileDict[opQid][subQuestion.id];

            for (let fileObj of files) {
              try {
                let base64Str = await this.convertFileToBase64(fileObj);
                base64Str = base64Str.split(',')[1];
                base64Files.push(base64Str);
                fileNames.push(fileObj.name);
              } catch (err) {
                console.error('File convert error:', err);
              }
            }
          }

          operationQuestions.push({
            operationQuestionId: subQuestion.id,
            subQuestionFile: base64Files,
            subQuestionFileName: fileNames
          });
        }

        answers.push({
          qid: opQid,
          operationQuestions: operationQuestions
        });
      }
      
      const answerSubmissionDTO = {
        examineeId: this.userInfo ? this.userInfo.uid : null,
        examId: this.joined_exam ? this.joined_exam.examid : null,
        answers
      };

      try {
        // await api.uploadOperationAnswer(answerSubmissionDTO);
        ElMessage.success('答案提交成功');
        await clearDatabase();
        localStorage.removeItem('joined_exam');
        localStorage.removeItem('fileDict');
        localStorage.removeItem('currentOperationIndex');
        localStorage.removeItem('flaggedOperationQuestions');
        sessionStorage.setItem(`submit_exam:${this.joined_exam.examid}`, 'true');
        this.thirdConfirmDialog = false;
        this.$router.push('/examinee-home');
      } catch (error) {
        ElMessage.error('答案提交失败');
        this.thirdConfirmDialog = false;
      }
      this.submitLoading = "true";
    },
    isAnswerCompleted(){
      if(this.resultQuestionOperations.length == this.answeredNum) {
        this.firstConfirmDialog = true;
      }else {
        this.notCompleteDialog = true;
      }
    },
    checkTimeAndDuration() {
      if (this.joined_exam) {
        const start = new Date(this.startTime).getTime();
        const current = new Date().getTime();
        
        // 计算当前时间和开始时间的差值（以毫秒为单位）
        const duration = current - start;
        // 60分钟对应的毫秒数
        const fortyFiveMinutesInMs = 60 * 60 * 1000;
        if (duration > fortyFiveMinutesInMs) { 
          return false; // 操作题开考超过60分钟：允许交卷
        } else {
          return true;
        }
      }else{
        return false;
      }
    },
    updateTimes() {
      const examAddTime = this.joined_exam.examAddTime || 0; // 默认加时时间为0
      const examineeAddTime = this.joined_exam.examineeAddTime || 0; // 默认加时时间为0
      this.startTime = new Date(this.joined_exam.examStartTime);
      this.endTime = new Date(this.joined_exam.examEndTime);
      
      // 根据 addTime 更新结束时间
      this.endTime.setMinutes(this.endTime.getMinutes() + examAddTime + examineeAddTime);
    },
    fetchExamineeInfo() {
      const uid = this.userInfo ? this.userInfo.uid : null;
      api.getExamineeExams(uid).then(response => {
        console.log('获取考试信息成功:', response.data);
        const exams = response.data;
        const exam = exams.find(item => item.examid === this.joined_exam.examid);
        localStorage.setItem('examineeInfo', JSON.stringify(exams));
        this.updateJoinedExam(exam);
        ElMessage.success('刷新成功');
      }).catch(error => {
        console.error('获取考生信息失败:', error);
        ElMessage.error('刷新失败');
      });
    },
    // 检查时间并执行操作
    async checkTimeAndSubmit () {
      if (this.endTime) {
        const end = new Date(this.endTime).getTime();
        const current = new Date().getTime();
        const remainingTime = end - current;
        console.log('111')
        if (remainingTime <= 21 * 1000 && remainingTime >= 20 * 1000 && remainingTime > 0) {
          await this.fetchExamineeInfo(); // 调用获取考生信息的方法
        }
        if (current >= end) {
          clearInterval(this.durationIntervalId);
          clearInterval(this.submitIntervalId);
          await this.submitAnswers(); // 假设这是你的提交答案函数
        }
      }

    },
    async handleFileChange(file, fileList, questionId) {
      try {
        const fileBlob = new Blob([file], { type: file.type });
        await saveFile(`${this.currentOperationQid}-${questionId}-${file.name}`, fileBlob);
        console.log('文件已存储到 IndexedDB');
      } catch (error) {
        console.error('Error uploading file:', error);
      }
    },
    async handleFileRemove(file, fileList, questionId) {
      try {
        const fileId = `${this.currentOperationQid}-${questionId}-${file.name}`;

        // 从IndexedDB中删除文件
        await deleteFile(fileId);

        console.log(`File ${file.name} removed successfully.`);
      } catch (error) {
        console.error('Error removing file:', error);
      }
    }
  },
  watch: {
    fileDict: {
      handler(newFileDict) {
        localStorage.setItem('fileDict', JSON.stringify(newFileDict));
        // 更新已答题数
        let num = 0;
        for (let qid in newFileDict) {
          if(Object.values(newFileDict[qid]).every(array => array.length > 0)){
            num++;
          }
        }
        this.answeredNum = num;
        //更新文件列表高度
        for (const key in newFileDict[this.currentOperationQid]) {
          this.$nextTick(() => {
            const element = this.$refs[`myElement-${this.currentOperationQid}-${key}`];
            if (element && element.length > 0) {
              if(newFileDict[this.currentOperationQid][key].length > 0) {
                element[0].style.height = `${newFileDict[this.currentOperationQid][key].length * 24}px`;
              }else{
                element[0].style.height = '';
              }
            }
          });
        }
      },
      deep: true
    },
    currentOperationIndex: {
      handler(newIndex) {
        //更新文件列表高度
        for (const key in this.fileDict[this.currentOperationQid]) {
          this.$nextTick(() => {
            const element = this.$refs[`myElement-${this.currentOperationQid}-${key}`];
            if (element && element.length > 0) {
              if(this.fileDict[this.currentOperationQid][key].length > 0) {
                element[0].style.height = `${this.fileDict[this.currentOperationQid][key].length * 24}px`;
              }else{
                element[0].style.height = '';
              }
            }
          });
        }
      },
      deep: true
    },
    joined_exam() {
      this.updateTimes()
    }
  },
  // 组件卸载时清除定时器
  onUnmounted() {
    clearInterval(this.durationIntervalId);
    clearInterval(this.submitIntervalId);
  }
};
</script>

<style scoped>
.app {
  width: 100%;
  padding: 20px;
  background-color: #f5f5f5;
  display: flex;
  flex-direction: column;
  height: 90vh;
}

.header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  background-color: #409EFF;
  padding: 10px;
  background-color: white;
  border-radius: 8px;
  box-sizing: border-box;
  position: relative;
  overflow: hidden;
}

.header::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 4px;
  background-color: #409EFF;
}

.header p {
  margin: 0;
}

.header .title {
  flex: 1;
}

.header .exam-title {
  font-size: 25px;
  font-weight: bold;
}

.header .user-info {
  display: flex;
  justify-content: flex-end;
  align-items: center;
}

.header .countdown {
  font-size: 20px;
  font-weight: bold;
  margin-left: 20px;
  padding-right: 20px;
}

.header .user-info .user-detail {
  display: flex;
  align-items: center;
}

.header .user-info .user-avatar {
  width: 50px;
  margin-right: 10px;
}

.exam-content {
  width: 100%;
  margin-top: 15px;
  background-color: white;
  padding: 20px;
  border-radius: 8px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  flex: 1;
  display: flex;
  box-sizing: border-box;
  height: calc(100% - 110px);
}

.exam-section {
  width: 45%;
  padding-left: 15px;
  padding-right: 15px;  
  display: flex;
  flex-direction: column;
  height: 100%;
}

.exam-info {
  flex: 1;
  display: flex;
  flex-direction: column;
}

.exam-info h3, .questions h3 {
  font-size: 20px;
  font-weight: bold;
}

.exam-info h4, .questions h4 {
  font-size: 18px;
  margin-top: 10px;
}

.questions {
  margin-top: 20px;
  max-height: 100%;
  overflow: auto;
}

.answer-section {
  margin-top: 20px;
}

.buttons {
  display: flex;
  justify-content: space-between;
  margin-top: 20px;
}

.buttons-right {
  display: flex;
  justify-content: flex-end;
}

.question-buttons {
  margin-top: 20px;
}

.pdf-preview {
  flex: 1;
  margin-top: 20px;
  display: flex;
}

.pdf-preview iframe {
  flex: 1;
}

.question-item {
  margin-bottom: 20px;
}

.upload-button {
  display: flex;
  justify-content: flex-end;
  margin-top: 10px;
  position: relative;
}

.active-btn {
  background-color: #24374a !important; /* 蓝绿色背景 */
  color: #fff !important; /* 白色文字 */
}

.answered {
  background-color: #409eff;
  color: #fff;
}

</style>